<template>
  <div>
    <main-header/>
    <div class="aboutUs-bg">
      <NavBar class="d-md-block d-none"/>
      <div class="container text-center">
        <div class="row">
          <div class="col-10 mx-auto aboutUs-txt">
            <h2 class="col-auto text-center border-bottom-title mb-6 primary-text">
              تاریخچه انتشارات شاهکار قلم
            </h2>
            <p>
              انتشارات شاهکار قلم افتخار دارد از سال 1402 فعالیت خود را در زمینه چاپ کتاب های دانشگاهی و کمک آموزشی آغاز
              کرده و همچنین همکاری با اساتید بزرگ و برتر کشور از جمله دکتر فرزاد آسایش واستاد.مقتدالانام روانبخش و استاد
              کوروش آسایش و استاد محسن عربی و سرکار خانم دکتر شهناز خیرخواه و علی گداری، امین ذوقی – سردار رحیم لیالی و
              جناب مهندس حسن سلطانی از مجموعه بزرگ بهنوش ایران و از شرکت نفت و گاز جناب آقای دکتر خداداد اسکندری و چاپ
              کتابهایی در زمینه رشد و توسعه در فروش ملک با استاد امیر همایون کاشانی کیا و استاد احد کاشانی کیا و امیر
              همایون کاشانی کیا همکاری داشتیم.
            </p>
          </div>
          <div class="col-10 mx-auto aboutUs-txt">
            <h2 class="col-auto text-center border-bottom-title mb-6 primary-text">
              درباره انتشارات شاهکار قلم
            </h2>
            <p>
              سپاس پروردگار را که توفیق ارائه خدمات علمی و آموزشی در گستره نشر فرهنگ و اندیشه های نو را به ما ارزانی
              داشت تا به برکت این منت بی انتها به نشر و ترویج آثار ماندگار و ارزشمندی در زمینه های علمی اقدام نمائیم.
              <br/>
              <br/>
              بی تردید رشد و توسعه علمی و فرهنگی کشور، بازتاب میزان تفکری است که فرهیختگان در مقام عمل به ظهور می
              رسانند. در این بین، مهم تر و حساس تر از همه، رسالت فرهیختگان و دانش اندوزانی می باشدکه در جهت پرورش
              استعدادهای فردی، برای پیشبرد اهداف اجتماعی و فرهنگی نیز محقق می گردد.
              <br/>
              <br/>
              با این امید که با استمرار فعالیت های انتشاراتی، بتوان گامی بلند در راه رشد و بالندگی فرهنگی برداشت.
              <br/>
              <br/>
              در پایان تصریح می گردد امتیازات ویژه ای برای فروش این اثر و سایر آثار منتشره از سوی انتشارات شاهکار قلم و
              آفتاب گیتی در نظر گرفته خواهد شد.
            </p>
          </div>
          <div class="col-10 mx-auto aboutUs-txt">
            <h2 class="col-auto text-center border-bottom-title mb-6 primary-text">
              بخش پذیرش اثر انتشارات شاهکار قلم
            </h2>
            <p class="text-right">
              شرایط و نحوه پذیرش اثر برای بررسی در انتشارات آفتاب گیتی و موسسه انتشاراتی شاهکار قلم
              <br/>
              <br/>
              شامل دو مؤسسه انتشاراتی آفتاب گیتی، شاهکار قلم(ناشر تخصصی کمک آموزشی و کتاب های ترجمه ) و  بر اساس
            </p>
            <ul class="text-right mr-5">
              <li>فقط آثار تایپ‌شده برای بررسی پذیرفته می‌شود.</li>
              <li>زمان تقریبی بررسی اثر حداقل 5 و حداکثر 10 روز کاری است.</li>
              <li>موسسه انتشاراتی آفتاب گیتی برای پذیرفتن یا نپذیرفتن آثار پیشنهادی بر اساس معیارها و ملاحظات خود تصمیم می‌گیرد.</li>
              <li>پذیرفته نشدن اثر لزوماً به معنای پایین بودن کیفیت آن نیست و انتشارات خود را ملزم به دادن توضیح یا انتقال نظر کارشناسان به مؤلف یا مترجم نمی‌داند.</li>
            </ul>

            <p class="text-right">
              برای بررسی آثار تألیفی در شاهکار قلم، لازم است متن کتاب رو حد اقل 20 صفحه برای انتشارات ارسال کنند تا در شورای بررسی انتشارات مورد تایید قرار بگیرد.
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>
  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import NavBar from "./navBar";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "aboutUs",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        }
      ]
    }
  },
  components: {NavigationDrawer, Footer, NavBar, MainHeader},
  data: () => ({
    drawer: false,

  })
}
</script>

<style scoped>

</style>
